module.exports = __webpack_public_path__ + "static/media/whale.abc26788.svg";